import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface CashBottomSheetProps {}

const CashBottomSheet: FC<CashBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <NolNoticeBottomSheet
      /*NOL 첫 결제 캐시백 유의사항*/
      title={'NOL 첫 결제 캐시백 유의사항'}
      isOpen={store.isCashbackBottomSheetOpen}
      onRequestClose={() => (store.isCashbackBottomSheetOpen = false)}
    >
      <ul>
        <li>NOL 포인트 10% 기본 적립 혜택과 중복 제공</li>
        <li>
          타 쿠폰 및 즉시할인, 포인트와 중복 사용 가능(단, 할인쿠폰 및 즉시할인, 포인트 사용 후 최종 카드 결제 금액이 첫
          결제 조건 금액 충족 시 혜택 제공)
        </li>
        <li>
          NOL/NOL 인터파크(NOL 인터파크투어/NOL 티켓)/트리플에서 간편결제(NOL 카드 페이)에 등록된 NOL 카드로 첫 결제 시
          혜택 제공
        </li>
        <li>
          혜택 제공 시점으로부터 13개월 내 NOL 카드 해지 및 탈회 시 제공 받은 혜택 금액이 현대카드를 통해서 현금으로
          청구 될 수 있음
        </li>
        <li>캐시백 제공 일정은 현대카드 또는 회원 사정에 따라 변경될 수 있음</li>
        <li>카드 이용 대금 결제일과 캐시백 제공일이 동일한 경우, 캐시백 금액이 이용 대금으로 납부될 수 있음</li>
        <li>카드 승인 후 취소, 부분취소, 반품, 품절, 환불 등으로 결제 금액 미달 시 혜택 제공 불가</li>
        <li>
          혜택 제공 시점에 대상 카드 해지, 분실, 교체(재발급 등), 정지(연체 등) 등의 경우 혜택 제공 불가(카드 상태가
          정상인 경우에 한해 제공)
        </li>
        <li>
          모든 가맹점은 현대카드 가맹점등록 및 업종 분류 기준이며, 가맹점명이 NOL/NOL 인터파크(NOL 인터파크투어/NOL
          티켓)/트리플인 경우에만 혜택이 적용 됨
        </li>
        <li>이외 자세한 내용은 현대카드 고객센터(1577-6000)로 문의 </li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(CashBottomSheet);
